/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Role } from '@/core/components/auth/auth.types'
import { LoadingList } from '@/core/components/LoadingList'
import { activitiesQueryOptions } from '@/core/components/sites/site/activities-and-products/activitiesQueryOptions'
import { promoCodeByIdQueryOptions } from '@/core/components/sites/site/rates-and-packages/promo-code/promoCodeQueryOptions'
import { ratesQueryOptions } from '@/core/components/sites/site/rates-and-packages/rates/ratesQueryOptions'
import {
  createFileRoute,
  ErrorComponent,
  redirect,
} from '@tanstack/react-router'
import { z } from 'zod'

const promoCodeSearchSchema = z.object({
  search: z.string().catch(''),
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  sortBy: z.enum(['code', 'title', 'discount', 'validity']).catch('code'),
  orderBy: z.enum(['asc', 'desc']).catch('desc'),
})

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit/'
)({
  validateSearch: (search) => promoCodeSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({
    context: { queryClient, auth },
    params: { promoCodeId, siteId },
  }) => {
    const promoCode = queryClient.ensureQueryData(
      promoCodeByIdQueryOptions(promoCodeId, auth.token!)
    )

    const rates = queryClient.ensureQueryData(
      ratesQueryOptions(siteId, auth.token!)
    )
    const activities = queryClient.ensureQueryData(
      activitiesQueryOptions(siteId, auth.token!)
    )

    return {
      rates,
      activities,
      promoCode,
    }
  },

  errorComponent: ErrorComponent,
  pendingComponent: LoadingList,
})
